export enum TaskWorkflowAction {
    None = 0,
    ReviewReject = 5000,
    ReviewApprove = 8000,
    Reopen = 11000,
}
